<template>
  <div>
    <obk-description-id-note-step step-number="1" />
    <obk-description-no-incognito-step step-number="2" />
    <obk-description-no-ad-blocker-step step-number="3" />
  </div>
</template>

<script>
import ObkDescriptionIdNoteStep
  from '@/base-components/onboarding/openBanking/obk-redirect-descriptions/ObkDescriptionIdNoteStep.vue';
import ObkDescriptionNoIncognitoStep
  from '@/base-components/onboarding/openBanking/obk-redirect-descriptions/ObkDescriptionNoIncognitoStep.vue';
import ObkDescriptionNoAdBlockerStep
  from '@/base-components/onboarding/openBanking/obk-redirect-descriptions/ObkDescriptionNoAdBlockerStep.vue';

export default {
  name: 'OpenBankingDefaultDescription',
  components: { ObkDescriptionNoAdBlockerStep, ObkDescriptionIdNoteStep, ObkDescriptionNoIncognitoStep },
};
</script>

<style scoped lang="scss">
</style>
